import { Inject, Injectable } from "@angular/core";
import * as urls from "./urls.json";
import { WebLogger } from "../../web-logger";
import { ENVIRONMENT_CONFIG, EnvironmentConfig } from "../../environment.config";

@Injectable({
  providedIn: 'root'
})
export class UrlService {
  private readonly env: string;

  constructor(@Inject(ENVIRONMENT_CONFIG) private config: EnvironmentConfig) {
    this.env = config.deployment || "default";
  }

  public getUrl(urlKey: UrlKey, urlParameters: object = {}): string {
    const envKey = this.env;
    let url = urls?.[urlKey]?.[envKey] || urls[urlKey]["default"];
    url = this.applyParametersToUrl(url, urlParameters);
    WebLogger.log({ message: "UrlService URL requested", payload: { urlKey, envKey, url } });
    return url;
  }

  private applyParametersToUrl(url: string, urlParameters: object): string {
    let finishedUrl: string = url;
    const parameterKeys: string[] = [...Object.keys(urlParameters)];

    // First, replace path parameters like {householdMemberId}
    parameterKeys.forEach((key) => {
      const placeholder = `{${key}}`;
      if (finishedUrl.includes(placeholder)) {
        finishedUrl = finishedUrl.replace(placeholder, encodeURIComponent(urlParameters[key]));
      }
    });

    // Then, add remaining parameters as query parameters
    const urlSearchParams = new URLSearchParams(finishedUrl.split('?')[1] || '');
    parameterKeys.forEach((key) => {
      const value = urlParameters[key];
      const placeholder = `{${key}}`;
      // Only add as query param if it wasn't used as a path parameter
      if (value !== undefined && !urlSearchParams.has(key) && !url.includes(placeholder)) {
        urlSearchParams.append(key, value);
      }
    });

    const baseUrl = finishedUrl.split('?')[0];
    const queryString = urlSearchParams.toString();
    return queryString ? `${baseUrl}?${queryString}` : baseUrl;
  }
}

export const enum UrlKey {
  aan_subgraph_url = "aan_subgraph_url",
  ago_subgraph_url = "ago_subgraph_url",
  estate_plan_status_url = "estate_plan_status_url",
  estate_plan_url = "estate_plan_url",
  external_iip_url = "external_iip_url",
  gatekeeper_url = "gatekeeper_url",
  rgh_url = "rgh_url",
  rob_graphql_url = "rob_graphql_url",
  vex_get_status_url = "vex_get_status_url",
  vex_post_estate_profile_url = "vex_post_estate_profile_url",
  rkn_base_url = "rkn_base_url",
  rke_base_url = "rke_base_url",
  rke_logon_url = "rke_logon_url",
  WEPS_PROXY = "wepsProxy",
  vanilla_sso_url = "vanilla_sso_url",
  zok_people_url = "zok_people_url",
  zok_people_sync_url = "zok_people_sync_url",
  zok_member_url = "zok_member_url",
  zok_delete_person_url = "zok_delete_person_url",
  zok_person_update_url = "zok_person_update_url",
}
